export default "__VITE_PUBLIC_ASSET__60c44ceb__"